import * as React from 'react';

const SvgDiscord = (props) => (
  <svg
    width={50}
    height={40}
    className="fill-current text-black dark:text-white"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M40.938 5.469h-.079a37.824 37.824 0 0 0-9.297-2.89c-.078 0-.078-.079-.078-.079l-.078.078c-.468.781-.86 1.64-1.172 2.422-1.718-.234-3.515-.39-5.312-.39-1.797 0-3.516.156-5.235.39-.312-.781-.703-1.64-1.171-2.422h-.157a37.823 37.823 0 0 0-9.297 2.89h-.078c-5.937 8.907-7.578 17.579-6.796 26.173 0 0 0 .078.078.078C5.625 34.297 9.53 36.25 13.75 37.5h.156c.86-1.25 1.64-2.5 2.344-3.828v-.078c0-.078-.078-.078-.078-.157-1.25-.468-2.5-1.015-3.594-1.718-.078 0-.078 0-.078-.078s0-.078.078-.157c.235-.156.469-.312.703-.547h.157c7.5 3.438 15.624 3.438 23.046 0h.157c.234.235.468.391.703.547.078.078.078.078.078.157 0 .078 0 .078-.078.078a21.622 21.622 0 0 1-3.594 1.718c-.078.079-.078.079-.078.157v.078a38.61 38.61 0 0 0 2.344 3.828h.156c4.14-1.25 8.047-3.203 11.484-5.781.078 0 .078-.078.078-.078.938-9.922-1.64-18.516-6.797-26.172ZM17.343 26.406c-2.266 0-4.14-2.11-4.14-4.61 0-2.577 1.874-4.608 4.14-4.608 2.343 0 4.14 2.03 4.14 4.609 0 2.5-1.875 4.61-4.14 4.61Zm15.234 0c-2.266 0-4.062-2.11-4.062-4.61 0-2.577 1.797-4.608 4.062-4.608 2.344 0 4.219 2.03 4.14 4.609 0 2.5-1.796 4.61-4.14 4.61Z" />
  </svg>
);

export default SvgDiscord;
